import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, Nav } from 'ionic-angular';
import "rxjs/add/operator/map";
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { MysqlService } from '../../../services/mysql.service';
import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';

import { LoginPage } from '../../login/login';
import { TabsPage } from '../../tabs/tabs';
import { FarmListPage } from '../farmList/farmList';
import { FarmDashboardPage } from '../farmDashboard/farmDashboard';

@Component({
  selector: 'page-addFarm',
  templateUrl: 'addFarm.html',
  // styleUrls: [ 'addFarm.scss', '../../theme/variables.scss' ]
})
export class AddFarmPage {

  farmDashboard: string = "farm";
  myreturnvalue;
  // public goshala = {};
  // public interfaceData = {};
  // public loadForm = false;
  // public farmForm: FormGroup;
  public loading;
  public type = {};
  public from = "";
  public clicked = false;
  validation_messages = {
      'farmType': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'ruralUrban': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'name': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'owner': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'email': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'contact': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'openHours': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'farmHistory': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'address': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'city': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'state': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'country': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      // 'division': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'region': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'continent': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'pincode': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'language': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'gbc': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'templeContactPerson': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'templeEmail': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'templeContactNumber': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'totalCows': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'totalCalves': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'totalBulls': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'totalOx': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'milkingYesNo': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'barnArea': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'barnUnitType': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'grazingArea': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'grazingUnitType': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'totalLandArea': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
      'landSizeUnitType': [{ type: 'required', message: 'This field is required.' }, { type: 'pattern', message: 'Not an accepted value.' }],
    }

    farmForm = new FormGroup({
      
      farmType: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      ruralUrban: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      name: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      owner: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      email: new FormControl('', [Validators.required]),
      contact: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      openHours: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      farmHistory: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      address: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      city: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      state: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      country: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      // division: new FormControl('',[Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      region: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      continent: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      pincode: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      language: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      gbc: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      templeContactPerson: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      templeEmail: new FormControl('', [Validators.required]),
      templeContactNumber: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      totalCows: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      totalCalves: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      totalBulls: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      totalOx: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      milkingYesNo: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      barnArea: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      barnUnitType: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      grazingArea: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      grazingUnitType: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      totalLandArea: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
      landSizeUnitType: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),

    });
   

  public goshala: any = {};
  public interfaceData = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, public myApp: ImcpaAppProvider, private dbService: MysqlService, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public nav: Nav ) {
    this.type = this.navParams.get("type");
    this.from = this.navParams.get("from");

    // if(this.navParams.get("from") === 'fromLoginPage'){
    //   this.getGoshala();
    // }

    console.log(this.navParams.get("goshala"));
    if(this.navParams.get("goshala") !== undefined && this.navParams.get("segmentTab") !== undefined){
      this.interfaceData = this.navParams.get("goshala");
      this.goshala = this.interfaceData;
      this.farmDashboard = this.navParams.get("segmentTab");
      console.log(this.navParams.get("goshala"));
    }
    if(this.navParams.get("from") === 'fromLoginPage'){
      this.getGoshala();
    }

    // this.delaySegments()
    

  }

   delaySegments(){
    setTimeout(()=> {
      this.farmDashboard = 'temple';
    },1);
    setTimeout(()=> {
      this.farmDashboard = 'cattle';
    },2);
    setTimeout(()=> {
      this.farmDashboard = 'land';
    },3);
    setTimeout(()=> {
      this.farmDashboard = 'staff';
    },4);
    setTimeout(()=> {
      this.farmDashboard = 'farm';
    },5);
  }


  // ngOnInit() {
  //   this.farmForm = new FormGroup({
  //   farmType: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   ruralUrban: new FormControl(this.goshala.ruralUrban, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   name: new FormControl(this.goshala.name, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   owner: new FormControl(this.goshala.owner, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   email: new FormControl('', [Validators.required, Validators.email]),
  //   contact: new FormControl(this.goshala.contact, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   openHours: new FormControl(this.goshala.openHours, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   farmHistory: new FormControl('', [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   address: new FormControl(this.goshala.address, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   city: new FormControl(this.goshala.city, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   state: new FormControl(this.goshala.state, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   country: new FormControl(this.goshala.country, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   // division: new FormControl('',[Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   region: new FormControl(this.goshala.region, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   continent: new FormControl(this.goshala.continent, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   pincode: new FormControl(this.goshala.pincode, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   language: new FormControl(this.goshala.language, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   gbc: new FormControl(this.goshala.gbc, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   templeContactPerson: new FormControl(this.goshala.templeContactPerson, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   templeEmail: new FormControl(this.goshala.templeEmail, [Validators.required, Validators.email]),
  //   templeContactNumber: new FormControl(this.goshala.templeContactNumber, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   totalCows: new FormControl(this.goshala.totalCows, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   totalCalves: new FormControl(this.goshala.totalCalves, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   totalBulls: new FormControl(this.goshala.totalBulls, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   totalOx: new FormControl(this.goshala.totalOx, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   milkingYesNo: new FormControl(this.goshala.MilkingYesNO, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   barnArea: new FormControl(this.goshala.barnArea, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   barnUnitType: new FormControl(this.goshala.barnUnitType, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   grazingArea: new FormControl(this.goshala.grazingArea, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   grazingUnitType: new FormControl(this.goshala.grazingUnitType, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   totalLandArea: new FormControl(this.goshala.totalLandArea, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),
  //   landSizeUnitType: new FormControl(this.goshala.landSizeUnitType, [Validators.required, Validators.pattern(/^(null.+|(?!null).*)$/)]),

  // });
  // }



  ionViewDidLoad() {
    // this.getGoshala();
    // this.delaySegments()
    console.log('ionViewDidLoad TempleDetailsPage');
  }
  
  goToLoginPage(){
    // if(this.myApp.isLoggedIn){
    this.myApp.access = {};
    this.myApp.isLoggedIn = false;  
    this.navCtrl.push(TabsPage);
    // this.nav.setRoot(LoginPage);
    // this.app.getRootNavs()[0].setRoot(LoginPage)
  }


  async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      content: 'Loading Data, please wait..',
    });
    return await this.loading.present();  
  }

  showToast() {
    if(this.type === 'Add Farm'){
    const toast = this.toastCtrl.create({
      message: 'Farm Added...',
      duration: 3000
      // showCloseButton: true,
      // closeButtonText: 'Ok'
    });
    toast.present();
    }
    if(this.type === 'Update Farm'){
    const toast = this.toastCtrl.create({
      message: 'Farm Info Updated...',
      duration: 3000
      // showCloseButton: true,
      // closeButtonText: 'Ok'
    });
    toast.present();
    }
  }

showToast2(obj, type) {
  if(type === 'failure'){    
      const toast = this.toastCtrl.create({
      message: "'" + obj + "' field is empty. Please complete all fields to register!",
      duration: 5000,
      showCloseButton: true,
      closeButtonText: 'Ok'
    });
    toast.present();
    } 
  if(type === 'success'){
      const toast = this.toastCtrl.create({
      message: "Successfully Registered!",
      // duration: 5000,
      showCloseButton: true,
      closeButtonText: 'Ok'
    });
    toast.present();
    } 
    if(type === 'error'){
      const toast = this.toastCtrl.create({
      message: "Please complete all required fields",
      // duration: 5000,
      showCloseButton: true,
      closeButtonText: 'Ok'
    });
    toast.present();
    } 
  }



  checkProperties(goshala) {
    console.log("Form validation function: " + goshala)
    for (var key in goshala) {
      if(key !== 'registered' && key !== 'registrationNo'){ 
        // if(!(goshala.country !== 'India' && (goshala.division === 'null' || goshala.division === null || goshala.division === '')) || (goshala.country === 'India' && (goshala.division === 'null' || goshala.division === null || goshala.division === '')) || (goshala.country === null && (goshala.division === 'null' || goshala.division === null || goshala.division === '')) || (goshala.country === 'India' && (goshala.division !== 'null' || goshala.division !== null || goshala.division !== ''))) {
          if (goshala[key] === null || goshala[key] === "" || goshala[key] === undefined || goshala[key] === "null" && !(goshala.country !== 'India' && (goshala.division === 'null' || goshala.division === null || goshala.division === ''))){
              this.showToast2(key, "failure");
              return;
            } 
          }
        // } 
      }
      this.type  = "register";
      this.registerGoshala(goshala); 
    }

  registerGoshala(goshala){

    let key = "";
    // this.goshala = goshala;
    this.clicked = true;
    
    if(goshala.videoLinks !== null && goshala.videoLinks !== undefined){
      console.log("Farm videoLinks: " + goshala.videoLinks);
    goshala.videoLinks = goshala.videoLinks.replace(/\r?\n|\r/g, ", ")
    }
    if(goshala.farmHistory !== null && goshala.farmHistory !== undefined){
      console.log("Farm Histroy: " + goshala.farmHistory);
    // goshala.farmHistory = goshala.farmHistory.replace(/\r?\n|\r/g, " ")
      goshala.farmHistory = goshala.farmHistory.replace(/'/g, "\\'");
      goshala.farmHistory = JSON.stringify(goshala.farmHistory).slice(1, -1);
    }
    if(goshala.address !== null && goshala.address !== undefined){
      console.log("Address: " + goshala.address);
    goshala.address = goshala.address.replace(/\r?\n|\r/g, ", ")
    }
    if(goshala.landComment !== null && goshala.landComment !== undefined){
      console.log("Land Comment: " + goshala.landComment);
    goshala.landComment = goshala.landComment.replace(/\r?\n|\r/g, " ")
    }
    if(goshala.openHours !== null && goshala.openHours !== undefined){
      console.log("Open Hours: " + goshala.openHours);
    goshala.openHours = goshala.openHours.replace(/\r?\n|\r/g, ", ")
    }
    this.delaySegments();
    setTimeout(()=> {
    
    if(this.farmForm.valid){
      this.clicked = false;
      this.presentLoading();

      goshala.updatePerson = this.myApp.access.id;
      if(goshala.milkingUnitType === 'Other'){
        goshala.milkingUnitType = goshala.milkingUnitTypeOther;
      }
      if(goshala.landSizeUnitType === 'Other'){
        goshala.landSizeUnitType = goshala.landSizeUnitTypeOther;
      }
      if(goshala.barnUnitType === 'Other'){
        goshala.barnUnitType = goshala.barnUnitTypeOther;
      }
      if(goshala.grazingUnitType === 'Other'){
        goshala.grazingUnitType = goshala.grazingUnitTypeOther;
      }
      goshala.registered = "Y";
        // goshala.updatePerson = this.myApp.access.id;
        this.dbService.fetchDataV2("UPDATE `farms` SET `name`='" + goshala.name + "', `farmType`='" + goshala.farmType + "', `ruralUrban`='" + goshala.ruralUrban + "', `goshalaUnder`='" + goshala.goshalaUnder + "', `farmContactPerson`='" + goshala.farmContactPerson + "',`farmContactNumber`='" + goshala.farmContactNumber + "', `farmEmail`='" + goshala.farmEmail + "', `website`='" + goshala.website + "', `facebook`='" + goshala.facebook +  "', `openHours`='" + goshala.openHours +  "', `videoLinks`='" + goshala.videoLinks + "', `farmHistory`='" + goshala.farmHistory + "', `address`='" + goshala.address + "', `city`='" + goshala.city + "', `state`='" + goshala.state + "', `country`='" + goshala.country + "', `division`='" + goshala.division + "', `continent`='" + goshala.continent + "', `pincode`='" + goshala.pincode + "', `region`='" + goshala.region + "', `gpsLat`='" + goshala.gpsLat + "', `gpsLong`='" + goshala.gpsLong + "', `language`='" + goshala.language + "', `templeContactPerson`='" + goshala.templeContactPerson + "', `templeContactNumber`='" + goshala.templeContactNumber + "', `templeEmail`='" + goshala.templeEmail + "', `gbc`='" + goshala.gbc + "', `totalCows`='" + goshala.totalCows + "', `totalBulls`='" + goshala.totalBulls + "', `totalOx`='" + goshala.totalOx + "', `totalCalves`='" + goshala.totalCalves + "', `milkingYesNo`='" + goshala.milkingYesNo + "', `totalMilkingCows`='" + goshala.totalMilkingCows + "', `totalMilkCollectedDay`='" + goshala.totalMilkCollectedDay + "', `milkingUnitType`='" + goshala.milkingUnitType + "', `barnArea`='" + goshala.barnArea + "', `barnUnitType`='" + goshala.barnUnitType + "', `grazingArea`='" + goshala.grazingArea + "', `grazingUnitType`='" + goshala.grazingUnitType + "', `totalLandArea`='" + goshala.totalLandArea + "', `landSizeUnitType`='" + goshala.landSizeUnitType + "', `landComment`='" + goshala.landComment + "', `managerCount`='" + goshala.managerCount + "', `farmworkersCount`='" + goshala.farmworkersCount + "', `volunteersCount`='" + goshala.volunteersCount + "', `registered`='" + goshala.registered +  "', `updatePerson`=" + goshala.updatePerson + " WHERE  `id`=" + goshala.id + ";")
        .map(res => res.json())
        .subscribe(res => {
          // this.clicked = true;
          this.loading.dismiss();
          if(this.navParams.get("from") === "fromLoginPage"){
            
            this.navCtrl.setRoot(AddFarmPage, {type: "Update Farm", from: "fromLoginPage", goshalaId: this.goshala.id});
            this.showToast2(key, "success");
          }
          
          if(this.type === "Update Farm" && this.navParams.get("from") !== "fromLoginPage") {
            this.getGoshala()
            // this.navCtrl.push(FarmDashboardPage, {goshala: this.goshala, profileSubSegment: this.farmDashboard, farmDashboard: 'profile'});
            // this.showToast();
            }
          }, error => {
          alert("FAILED, to fetch from php : "+ error);
          this.myreturnvalue = "Error : " + error;
          console.log(this.myreturnvalue)
          this.loading.dismiss();
        });
      }  else if(this.farmForm.invalid){
      this.showToast2(key, "error");
      } 
    },6);
  }


  addNewGoshala(goshala){
    this.presentLoading();
    if(goshala.videoLinks !== null && goshala.videoLinks !== undefined){
      console.log("Farm videoLinks: " + goshala.videoLinks);
      goshala.videoLinks = goshala.videoLinks.replace(/\r?\n|\r/g, ", ")
    }
    if(goshala.farmHistory !== null && goshala.farmHistory !== undefined){
      console.log("Farm Histroy: " + goshala.farmHistory);
      goshala.farmHistory = goshala.farmHistory.replace(/\r?\n|\r/g, " ")
      goshala.farmHistory = goshala.farmHistory.replace(/'/g, "\\'");
      goshala.farmHistory = JSON.stringify(goshala.farmHistory).slice(1, -1);
    }
    if(goshala.address !== null && goshala.address !== undefined){
      console.log("Address: " + goshala.address);
    goshala.address = goshala.address.replace(/\r?\n|\r/g, ", ")
    }
    if(goshala.landComment !== null && goshala.landComment !== undefined){
      console.log("Land Comment: " + goshala.landComment);
    goshala.landComment = goshala.landComment.replace(/\r?\n|\r/g, " ")
    }
    if(goshala.openHours !== null && goshala.openHours !== undefined){
      console.log("Open Hours: " + goshala.openHours);
    goshala.openHours = goshala.openHours.replace(/\r?\n|\r/g, ", ")
    }
    goshala.updatePerson = this.myApp.access.id; 
    if(goshala.milkingUnitType === 'Other'){
      goshala.milkingUnitType = goshala.milkingUnitTypeOther;
    }
    if(goshala.landSizeUnitType === 'Other'){
      goshala.landSizeUnitType = goshala.landSizeUnitTypeOther;
    }
    if(goshala.barnUnitType === 'Other'){
        goshala.barnUnitType = goshala.barnUnitTypeOther;
      }
      if(goshala.grazingUnitType === 'Other'){
        goshala.grazingUnitType = goshala.grazingUnitTypeOther;
      }
    if(this.type ===  'Add Farm'){
      this.dbService.fetchDataV2("insert into farms(name,farmType,ruralUrban,goshalaUnder,farmContactPerson,farmContactNumber,farmEmail,website,facebook,openHours,videoLinks,farmHistory,address,city,state,country,division,continent,pincode,region,gpsLat,gpsLong,language,templeContactPerson,templeContactNumber,templeEmail,gbc,totalCows,totalBulls,totalOx,totalCalves,milkingYesNo,totalMilkingCows,totalMilkCollectedDay,milkingUnitType,barnArea,barnUnitType,grazingArea,grazingUnitType,totalLandArea,landSizeUnitType,landComment,managerCount,farmworkersCount,volunteersCount,updatePerson) values(" + "'" + goshala.name + "','" + goshala.farmType + "','" + goshala.ruralUrban + "','" + goshala.goshalaUnder + "','" + goshala.farmContactPerson + "','" + goshala.farmContactNumber + "','" + goshala.farmEmail + "','" + goshala.website + "','" + goshala.facebook + "','" + goshala.openHours + "','" + goshala.videoLinks + "','" + goshala.farmHistory + "','" + goshala.address + "','" + goshala.city + "','" + goshala.state + "','" + goshala.country + "','" + goshala.division + "','" + goshala.continent + "','" +  goshala.pincode + "','" +  goshala.region + "','" +  goshala.gpsLat + "','" + goshala.gpsLong + "','" + goshala.language + "','" + goshala.templeContactPerson + "','" + goshala.templeContactNumber + "','" + goshala.templeEmail + "','" + goshala.gbc + "','" + goshala.totalCows + "','" + goshala.totalBulls + "','" + goshala.totalOx + "','" + goshala.totalCalves + "','" + goshala.milkingYesNo + "','" + goshala.totalMilkingCows + "','" + goshala.totalMilkCollectedDay + "','" + goshala.milkingUnitType + "','" + goshala.barnArea + "','" + goshala.barnUnitType + "','" + goshala.grazingArea + "','" + goshala.grazingUnitType + "','" + goshala.totalLandArea + "','" + goshala.landSizeUnitType + "','" + goshala.landComment + "','" + goshala.managerCount + "','" + goshala.farmworkersCount + "','" + goshala.volunteersCount + "'," + goshala.updatePerson + ")")
        .map(res => res.json())
        .subscribe(res => {
          this.loading.dismiss();
          this.navCtrl.push(FarmListPage);
          this.showToast()
          // this.tables=res.data;

          }, error => {
          alert("FAILED, to fetch from php : "+ error);
          this.myreturnvalue = "Error : " + error;
          console.log(this.myreturnvalue)
          this.loading.dismiss();
        });
    }
    if(this.type === 'Update Farm'){
    this.dbService.fetchDataV2("UPDATE `farms` SET `name`='" + goshala.name + "', `farmType`='" + goshala.farmType + "', `ruralUrban`='" + goshala.ruralUrban + "', `goshalaUnder`='" + goshala.goshalaUnder + "', `farmContactPerson`='" + goshala.farmContactPerson + "',`farmContactNumber`='" + goshala.farmContactNumber + "', `farmEmail`='" + goshala.farmEmail + "', `website`='" + goshala.website + "', `facebook`='" + goshala.facebook +  "', `openHours`='" + goshala.openHours +  "', `videoLinks`='" + goshala.videoLinks + "', `farmHistory`='" + goshala.farmHistory + "', `address`='" + goshala.address + "', `city`='" + goshala.city + "', `state`='" + goshala.state + "', `country`='" + goshala.country + "', `division`='" + goshala.division + "', `continent`='" + goshala.continent + "', `pincode`='" + goshala.pincode + "', `region`='" + goshala.region + "', `gpsLat`='" + goshala.gpsLat + "', `gpsLong`='" + goshala.gpsLong + "', `language`='" + goshala.language + "', `templeContactPerson`='" + goshala.templeContactPerson + "', `templeContactNumber`='" + goshala.templeContactNumber + "', `templeEmail`='" + goshala.templeEmail + "', `gbc`='" + goshala.gbc + "', `totalCows`='" + goshala.totalCows + "', `totalBulls`='" + goshala.totalBulls + "', `totalOx`='" + goshala.totalOx + "', `totalCalves`='" + goshala.totalCalves + "', `milkingYesNo`='" + goshala.milkingYesNo + "', `totalMilkingCows`='" + goshala.totalMilkingCows + "', `totalMilkCollectedDay`='" + goshala.totalMilkCollectedDay + "', `milkingUnitType`='" + goshala.milkingUnitType + "', `barnArea`='" + goshala.barnArea + "', `barnUnitType`='" + goshala.barnUnitType + "', `grazingArea`='" + goshala.grazingArea + "', `grazingUnitType`='" + goshala.grazingUnitType + "', `totalLandArea`='" + goshala.totalLandArea + "', `landSizeUnitType`='" + goshala.landSizeUnitType + "', `landComment`='" + goshala.landComment + "', `managerCount`='" + goshala.managerCount + "', `farmworkersCount`='" + goshala.farmworkersCount + "', `volunteersCount`='" + goshala.volunteersCount + "', `updatePerson`=" + goshala.updatePerson + " WHERE  `id`=" + goshala.id + ";")
      .map(res => res.json())
      .subscribe(res => {

        this.loading.dismiss();
        if(this.navParams.get("from") === "fromLoginPage"){
          this.navCtrl.setRoot(AddFarmPage, {type: "Update Farm", from: "fromLoginPage", goshalaId: this.goshala.id});
          this.showToast();
        }
        
        if(this.type === "Update Farm" && this.navParams.get("from") !== "fromLoginPage") {
          this.getGoshala();
          
          }
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
    }
  }
  
    getGoshala(){
    this.presentLoading()
    let goshala_id = "";
    if(this.navParams.get("from") === "fromLoginPage"){
      goshala_id = this.navParams.get("goshalaId");
    }
    if(this.type === "Update Farm" && this.navParams.get("from") !== "fromLoginPage"){
      goshala_id = this.goshala.id;
    }
    
    this.dbService.fetchDataV2('SELECT * FROM farms f where id = ' + goshala_id)
      .map(res => res.json())
      .subscribe(res => {
          
        this.goshala = res.data[0];
        console.log("Res Data:" + res.data[0])
        // this.goshala = this.interfaceData;
        console.log(this.goshala);
        // this.delaySegments()
        this.loading.dismiss();
        if(this.type === "Update Farm" && this.navParams.get("from") !== "fromLoginPage"){
          this.navCtrl.push(FarmDashboardPage, {goshala: this.goshala, profileSubSegment: this.farmDashboard, farmDashboard: 'profile'});
          this.showToast();
        }
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/farms/addFarm/addFarm.ts